firebird.controller('deviceSelectionCtrl', [
    '$rootScope',
    '$scope',
    '$q',
    '$sce',
    '$window',
    '$timeout',
    '$compile',
    'cookieService',
    'logService',
    'avDeviceService',
    'avDeviceSettingsService',
    'helperService',
    'storageService',
    'connectivityService',
    'phoneConferenceService',
    'attendeeService',
    'analyticsWrapperService',
    'routerService',
    'meetingService',
    'virtualBackgroundService',
    'localizationService',
    'executionEnvironmentEnum',
    'attendeeListService',
    function (
        $rootScope,
        $scope,
        $q,
        $sce,
        $window,
        $timeout,
        $compile,
        cookieService,
        logService,
        avDeviceService,
        avDeviceSettingsService,
        helperService,
        storageService,
        connectivityService,
        phoneConferenceService,
        attendeeService,
        analyticsWrapperService,
        routerService,
        meetingService,
        virtualBackgroundService,
        localizationService,
        executionEnvironmentEnum,
        attendeeListService
    ) {
        var self = this;

        const logger = logService.createLoggerWithSource('deviceSelectionCtrl');

        self.modalState = 'closed';

        self.currentlySelectedMic = {};
        self.currentlySelectedWebcam = {};
        self.currentlySelectedSpeaker = {};

        self.getAudioOnlyStream = getAudioOnlyStream;
        self.getVideoOnlyStream = getVideoOnlyStream;
        self.stopActiveStream = stopActiveStream;
        self.stopStream = stopStream;
        self.audioOnlyStreamTimeout = null;
        self.videoOnlyStreamTimeout = null;
        self.clearAudioOnlyStreamTimeout = clearAudioOnlyStreamTimeout;
        self.clearVideoOnlyStreamTimeout = clearVideoOnlyStreamTimeout;

        self.microphones = [];
        self.webcams = [];
        self.speakers = [];

        self.micLevel = 0;

        self.timeoutToSetFeedToVideoElementForVDI = 500;
        self.timeoutToSetFeedToVideoElementForNonVDI = 0;

        self.checkDevicePermissions = checkDevicePermissions;
        self.joinMeeting = joinMeeting;
        self.cacheJoinEvent = cacheJoinEvent;
        self.cleanUp = cleanUp;

        self.shouldShowCamera = shouldShowCamera;

        //Represents initial getUserMedia request for each device
        //If true, loading UI will be visible until streams are retrieved
        self.devicesLoading = {
            audioInput: false,
            videoInput: false
        };

        self.currentAudioStreamCounter = 0;
        self.currentVideoStreamCounter = 0;

        //True when waiting for video element 'play' event
        self.webcamPreviewLoading = false;

        self.videoFilterLoading = false;

        self.getDeviceList = getDeviceList;
        self.previewDeviceClick = previewDeviceClick;
        self.previewDevice = previewDevice;
        self.isDeviceCurrentlyPreviewed = isDeviceCurrentlyPreviewed;
        self.previewDefaultDevices = previewDefaultDevices;
        self.checkForUndetectedDevices = checkForUndetectedDevices;
        self.checkForBTHeadset = checkForBTHeadset;
        self.hasWebcamError = false;
        self.clearLoadingDevice = clearLoadingDevice;
        self.setLoadingDeviceToTrue = setLoadingDeviceToTrue;
        self.getCurrentWebcamAspectRatio = getCurrentWebcamAspectRatio;

        self.selectSpeaker = selectSpeaker;
        self.setAudioSink = setAudioSink;
        self.getSpeakerPreviewAudioSink = getSpeakerPreviewAudioSink;
        self.testSpeakers = testSpeakers;
        self.speakerOn = false;
        self.speakerTestSource = avDeviceService.getAudioOutputTestSource();

        self.joinWithPhoneAudio = false;
        self.setJoinWithPhoneAudio = setJoinWithPhoneAudio;
        self.phoneNumber = '';
        self.phonePin = '';

        self.populateDeviceLists = populateDeviceLists;
        self.populateSingleDeviceList = populateSingleDeviceList;
        self.clearDeviceLists = clearDeviceLists;

        self.toggleShowDeviceSelectionCheckbox = toggleShowDeviceSelectionCheckbox;

        //device errors
        self.getDevicePopoverPlacement = getDevicePopoverPlacement;
        self.showDevicePopover = showDevicePopover;
        self.showDeviceDetectionPopover = showDeviceDetectionPopover;
        self.showPopoverForDeviceChange = showPopoverForDeviceChange;
        self.hideAllDeviceSelectionErrorPopOver = hideAllDeviceSelectionErrorPopOver;
        self.showDeviceBlockedPopoverFor = showDeviceBlockedPopoverFor;
        self.showMicrophoneAndWebcamDeviceBlockedPopOver = showMicrophoneAndWebcamDeviceBlockedPopOver;
        self.setupDeviceBlockedPopover = setupDeviceBlockedPopover;
        self.refreshPage = routerService.refreshPage;
        self.usePhoneAudioDueToDeviceError = usePhoneAudioDueToDeviceError;
        self.getDevicePermissionFor = getDevicePermissionFor;
        self.isElectronOnMac = helperService.isElectronOnMac();
        self.devicePreviewErrorHandler = devicePreviewErrorHandler;

        self.openMicCamPermissionTroubleShootPage = avDeviceService.openMicCamPermissionTroubleShootPage;
        self.openMicCamPermissionTroubleShootPageForElectron =
            avDeviceService.openMicCamPermissionTroubleShootPageForElectron;
        self.openMicrophoneSystemPreference = avDeviceService.openMicrophoneSystemPreference;
        self.openCameraSystemPreference = avDeviceService.openCameraSystemPreference;
        self.refreshDeviceListAndPreviewDefault = refreshDeviceListAndPreviewDefault;

        self.chromeWithSystemPermissionIssue = false;
        self.VDIRef = helperService.getVDIRef();
        self.showContentsOnTopOfVideo = self.VDIRef.showContentsOnTopOfVideo;
        self.showTestAudioOutputOption = self.VDIRef.showTestAudioOutputOption;
        self.showAudioInputMicLevelIndicator = self.VDIRef.showAudioInputMicLevelIndicator;

        //What will be shown inside the popover
        self.contentContainer = {
            micNotFoundError: '#deviceSelectionMicNotFoundPopoverContent',
            webcamNotFoundError: '#deviceSelectionWebcamNotFoundPopoverContent',
            speakerNotFoundError: '#deviceSelectionSpeakerNotFoundPopoverContent',
            micNotReadableError: '#deviceSelectionMicNotReadablePopoverContent',
            webcamNotReadableError: '#deviceSelectionWebcamNotReadablePopoverContent',
            micTimedoutError: '#deviceSelectionMicTimedoutPopoverContent',
            webcamTimedoutError: '#deviceSelectionWebcamTimedoutPopoverContent',
            micInUseError: '#deviceSelectionMicInUsePopoverContent',
            webcamInUseError: '#deviceSelectionWebcamInUsePopoverContent',
            micGenericError: '#deviceSelectionMicGenericPopoverContent',
            webcamGenericError: '#deviceSelectionWebcamGenericPopoverContent'
        };

        //Where the popover will be shown
        self.popoverElement = {
            micDropDown: '.mic-dropdown-container .dropdown',
            camDropDown: '.webcam-dropdown-container .dropdown',
            speakerDropDown: '.speaker-dropdown-container .dropdown'
        };

        self.devicePopoversQueue = {
            mic: [],
            webcam: [],
            speaker: []
        };

        self.devicePopovers = [
            {
                name: 'micNotFoundError',
                device: 'mic',
                element: self.popoverElement.micDropDown,
                content: self.contentContainer.micNotFoundError
            },
            {
                name: 'webcamNotFoundError',
                device: 'webcam',
                element: self.popoverElement.camDropDown,
                content: self.contentContainer.webcamNotFoundError
            },
            {
                name: 'speakerNotFoundError',
                device: 'speaker',
                element: self.popoverElement.speakerDropDown,
                content: self.contentContainer.speakerNotFoundError
            },
            {
                name: 'micNotReadableError',
                device: 'mic',
                element: self.popoverElement.micDropDown,
                content: self.contentContainer.micNotReadableError
            },
            {
                name: 'webcamNotReadableError',
                device: 'webcam',
                element: self.popoverElement.camDropDown,
                content: self.contentContainer.webcamNotReadableError
            },
            {
                name: 'micTimedoutError',
                device: 'mic',
                element: self.popoverElement.micDropDown,
                content: self.contentContainer.micTimedoutError
            },
            {
                name: 'webcamTimedoutError',
                device: 'webcam',
                element: self.popoverElement.camDropDown,
                content: self.contentContainer.webcamTimedoutError
            },
            {
                name: 'micInUseError',
                device: 'mic',
                element: self.popoverElement.micDropDown,
                content: self.contentContainer.micInUseError
            },
            {
                name: 'webcamInUseError',
                device: 'webcam',
                element: self.popoverElement.camDropDown,
                content: self.contentContainer.webcamInUseError
            },
            {
                name: 'micGenericError',
                device: 'mic',
                element: self.popoverElement.micDropDown,
                content: self.contentContainer.micGenericError
            },
            {
                name: 'webcamGenericError',
                device: 'webcam',
                element: self.popoverElement.camDropDown,
                content: self.contentContainer.webcamGenericError
            }
        ];

        self.addToNotificationQueue = addToNotificationQueue;
        self.getHighestAvailablePriorityQueue = getHighestAvailablePriorityQueue;
        self.showNextAvailablePopover = showNextAvailablePopover;
        self.removePopoverIfItExists = removePopoverIfItExists;
        self.removePopoverFromElement = removePopoverFromElement;
        self.shouldIgnorePopoverTemplate = shouldIgnorePopoverTemplate;

        self.e2eePhoneAudioDisabled = e2eePhoneAudioDisabled;

        self.setDisconnectAudio = setDisconnectAudio;
        self.disconnectAudio = false;
        self.audioDisconnectEnabled = meetingService.getEnableAudioDisconnect;

        self.getCurrentlySelectedMicLabel = getCurrentlySelectedMicLabel;
        self.getCurrentlySelectedSpeakerLabel = getCurrentlySelectedSpeakerLabel;
        self.getSpeakerSelectionTooltip = getSpeakerSelectionTooltip;

        $scope.$on('show-modal', onShowModal);
        $scope.$on('hide-modal', onHideModal);
        $scope.$on('device-changed-during-device-preview', onDeviceChangedDuringDevicePreview);

        self.filteredBgStreamRequested = false;
        $scope.$on('virtual-background-stream-error', onVirtualBackgroundStreamError);
        $scope.$on('virtual-background-stream-started', onVirtualBackgroundStreamStarted);
        $scope.$on('virtual-background-initialized', onVirtualBackgroundInitialized);

        $scope.$on('e2ee-enabled', onE2EEEnabled);
        $scope.$on('e2ee-disabled', digest);
        $scope.$on('update-local-join-audio-muted', onUpdateLocalJoinAudioMuted);
        $scope.$on('security-settings-updated', onSecuritySettingsUpdated);
        $scope.$on('toggle-modal-on-preview', onModalToggledInPreview);
        $scope.$on('room-client-detected', onRoomClientDetected);

        self.onScopeDestroyed = onScopeDestroyed;
        $scope.$on('$destroy', function () {
            self.onScopeDestroyed();
        });

        self.applyVideoPreviewListener = applyVideoPreviewListener;
        self.videoPreviewListenerApplied = false;
        self.onVideoPreviewPlay = onVideoPreviewPlay;
        self.micPreviewBtnDisabled = micPreviewBtnDisabled;
        self.webcamPreviewBtnDisabled = webcamPreviewBtnDisabled;

        self.onWindowResize = onWindowResize;
        $window.$($window).on('resize', self.onWindowResize);

        //Vertical Join funcs
        self.toggleMicPreview = toggleMicPreview;
        self.micPreviewOn = false;
        self.getMicPreviewTooltip = getMicPreviewTooltip;
        self.getWebcamPreviewTooltip = getWebcamPreviewTooltip;
        self.updateDeviceMessage = updateDeviceMessage;
        self.deviceMessage = '';
        self.getDoNotShowDialogTooltip = getDoNotShowDialogTooltip;

        self.showNoAudioRoomClientConnectedAlert = showNoAudioRoomClientConnectedAlert;
        self.onRoomClientDetected = onRoomClientDetected;
        self.hasRoomClient = false;

        self.isJoinMuteLimitReach = isJoinMuteLimitReach;

        self.startTime = 0;

        init();

        ////////////////////////

        function getCurrentlySelectedMicLabel() {
            const selectedMic = self.microphones.find(x => self.isDeviceCurrentlyPreviewed(x));
            return selectedMic?.fullDisplayName ?? '';
        }

        function getCurrentlySelectedSpeakerLabel() {
            const selectedSpeaker = self.speakers.find(x => self.isDeviceCurrentlyPreviewed(x));
            return selectedSpeaker?.fullDisplayName ?? '';
        }

        function getSpeakerSelectionTooltip() {
            if (self.VDIRef.getVdiType() !== executionEnvironmentEnum.Azure) {
                return '';
            }

            return localizationService.translate('DEVICE_SELECTION_PREVIEW.AZURE_VDI_SPEAKER_SELECTION_LIMITED');
        }

        function init() {
            var phoneInfo = phoneConferenceService.getPhoneData();
            if (phoneInfo) {
                self.phoneNumber = phoneInfo.phoneNumberFree || phoneInfo.phoneNumberToll;
                self.phonePin =
                    (attendeeService.getIsPresenter() ? phoneInfo.presenterPIN : phoneInfo.attendeePIN) + '#';
            } else {
                logger.error('#init: Phone Info not available');
            }

            $window.$('#deviceSelection').on('shown.bs.modal', function () {
                if (self.hasRoomClient) {
                    self.showNoAudioRoomClientConnectedAlert();
                }
            });

            digest();
        }

        function onWindowResize() {
            var popoverContainerAll = $window.$('#deviceSelection .has-popover');
            var curPopoverContainer = null;

            try {
                //Popovers can be active, but hidden
                //Multiple containers can have an active popover (mic, webcam, speaker)
                //Only one popover can be visible at a time

                //Find the popoverContainer with a visible popover
                for (var i = 0; i < popoverContainerAll.length; i++) {
                    //'eq()' will return the jquery-wrapped object at a given index
                    if (popoverContainerAll.eq(i).attr('aria-describedby') !== undefined) {
                        curPopoverContainer = popoverContainerAll.eq(i);
                        break;
                    }
                }

                //If popover exists and popover container visible, re-show on window resize
                if (curPopoverContainer && curPopoverContainer.is(':visible')) {
                    curPopoverContainer.popover('show');
                }
            } catch (e) {
                logger.error('onWindowResize', 'error', e);
            }
        }

        function onRoomClientDetected() {
            self.hasRoomClient = true;
            self.showNoAudioRoomClientConnectedAlert();
        }

        function showNoAudioRoomClientConnectedAlert() {
            var attendeeList = attendeeListService.getAttendeeList();
            var hasRoomClient = false;
            attendeeList.forEach(function (att) {
                if (att.uniteRoomsUserId) {
                    hasRoomClient = true;
                }
            });

            self.hasRoomClient = hasRoomClient;

            if (
                hasRoomClient &&
                meetingService.getEnableAudioDisconnect() &&
                storageService.get('showNoAudioPrompt') !== false
            ) {
                self.showDevicePopover(
                    $window.$('#device-selection-choose-audio-disconnect'),
                    $window.$('#deviceSelectionNoAudioPopoverContent .device-selection-container')
                );
            }
        }

        function onShowModal(e, modalName) {
            if (modalName === 'deviceSelection') {
                self.startTime = Date.now();
                connectivityService.setIsInDeviceSelectionFlow(true);
                meetingService.setHasShownDeviceSelectionModal(true);

                if (!self.VDIRef.showContentsOnTopOfVideo) {
                    // VDI - Janus.init not called at this point. Hence Janus.hasVDI is not set. So need to update modals open count manually.
                    if ($window.Janus?.incrementModalsOpenInVdiCount) {
                        $window.Janus.incrementModalsOpenInVdiCount();
                    }
                }

                self.showNoAudioRoomClientConnectedAlert();

                self.applyVideoPreviewListener();

                self.setJoinWithPhoneAudio(storageService.get('using-phone-for-audio'));

                self.checkDevicePermissions()
                    .catch(function (err) {
                        logger.error('onShowModal', 'Error in checkDevicePermissions', err);
                    })
                    .then(function () {
                        self.modalState = 'open';
                        digest();

                        analyticsWrapperService.eventTrack('Meeting - Device Selection Preview - Modal Shown', {
                            sfuEvent: true,
                            msgflow: 'device-preview:open'
                        });

                        return self.getDeviceList();
                    })
                    .catch(function (err) {
                        logger.error('onShowModal', 'Error in getDeviceList', err);
                    })
                    .then(function () {
                        if (!self.micPreviewBtnDisabled()) {
                            if (storageService.get('join-flow-audio-muted') === null) {
                                //First time seeing join flow
                                self.micPreviewOn = attendeeService.getIsHost();
                            } else {
                                self.micPreviewOn = storageService.get('join-flow-audio-muted') === false;
                            }
                        }

                        self.updateDeviceMessage();

                        return self.previewDefaultDevices();
                    })
                    .catch(function (err) {
                        logger.error('onShowModal', 'Error in previewDefaultDevices', err);
                    })
                    .finally(function () {
                        if (self.modalState === 'closed') {
                            logger.debug('onShowModal finally reached after modal closed... returning');
                            return;
                        }
                        $timeout(function () {
                            self.setupDeviceBlockedPopover();
                            self.checkForUndetectedDevices();

                            //There is an edge case in which Bootstrap dropdown doesn't get properly initiated
                            //This will fix that if it happens, otherwise, this has no effect
                            //
                            //There isn't a way to detect this buggy state, so we call it each time the modal opens
                            //Timeout needed for elements in modal to finish rendering
                            $window.$('.dropdown-toggle').dropdown();
                        }, 2000);
                    });
            }
        }

        function onHideModal(e, modalName) {
            if (modalName.indexOf('deviceSelection') !== -1) {
                self.cleanUp();
            }
        }

        function checkDevicePermissions() {
            //If no devices found, skip permissions checks
            if (!avDeviceService.hasMicrophone() && !avDeviceService.hasCamera()) {
                var deferred = $q.defer();
                deferred.resolve();
                return deferred.promise;
            }

            return avDeviceService.startDevicePermissionsFlow();
        }

        function joinMeeting(opts) {
            //Normally, non-explicitly-chosen devices are stored when joining a meeting,
            //and explicitly-chosen devices are stored when manually switching to a different device...
            //
            //For this Device Preview flow, devices should be saved for both
            if (self.currentlySelectedMic && self.currentlySelectedMic.deviceInfo) {
                logger.debug('Setting stored audio input device: ' + self.currentlySelectedMic.deviceInfo.deviceId);
                avDeviceSettingsService.setExplicitlyChosenAudioIn(
                    self.currentlySelectedMic.deviceInfo.deviceId,
                    self.currentlySelectedMic.deviceInfo.originalLabel
                );
            } else {
                logger.debug('Joining without a selected mic');
            }

            const videoElement = $window.$('#video-only-container video');
            if (videoElement) {
                self.VDIRef.destroyVideoElement(videoElement);
            }
            if (self.currentlySelectedWebcam && self.currentlySelectedWebcam.deviceInfo) {
                logger.debug('Setting stored video input device: ' + self.currentlySelectedWebcam.deviceInfo.deviceId);
                avDeviceSettingsService.setExplicitlyChosenVideo(
                    self.currentlySelectedWebcam.deviceInfo.deviceId,
                    self.currentlySelectedWebcam.deviceInfo.originalLabel
                );
            } else {
                logger.debug('Joining without a selected webcam');
            }

            if (self.currentlySelectedSpeaker && self.currentlySelectedSpeaker.deviceInfo) {
                logger.debug(
                    'Setting stored audio output device: ' + self.currentlySelectedSpeaker.deviceInfo.deviceId
                );
                avDeviceSettingsService.setExplicitlyChosenAudioOut(
                    self.currentlySelectedSpeaker.deviceInfo.deviceId,
                    self.currentlySelectedSpeaker.deviceInfo.originalLabel
                );
            } else {
                logger.debug('Joining without a selected speaker');
            }

            logger.debug('Joining with phone audio:' + self.joinWithPhoneAudio);
            connectivityService.setAudioThroughPhone(self.joinWithPhoneAudio, true);
            if (self.disconnectAudio) {
                avDeviceService.toggleMuteAudioInputAndOutput();
            }

            attendeeService.setBroadcastOption({
                video: avDeviceService.hasCamera(),
                audio: avDeviceService.hasMicrophone()
            });

            if (meetingService.getVerticalJoinFlowEnabled()) {
                let audioMuted = !self.micPreviewOn || self.micPreviewBtnDisabled();
                let videoMuted = !opts || !opts.webcamOn || self.webcamPreviewBtnDisabled(true);
                attendeeService.setIsAudioMuted(audioMuted);
                attendeeService.setIsVideoMuted(videoMuted);
                $rootScope.$broadcast('video-muted-updated');
                if (!self.micPreviewBtnDisabled()) {
                    storageService.set('join-flow-audio-muted', audioMuted);
                }
            }

            analyticsWrapperService.eventTrack('Meeting - Device Selection Preview - Join Meeting', {
                sfuEvent: true,
                msgflow: 'device-preview:join'
            });

            //Clear getUserMedia request timeouts
            self.clearAudioOnlyStreamTimeout();
            self.clearVideoOnlyStreamTimeout();

            //User joined the meeting before devices finished loading -- do not count modal has "has been shown"
            //This will effectively show the Devices Popover after they join the meeting, to let them know what devices are in use
            if (self.devicesLoading.audioInput || self.devicesLoading.videoInput) {
                meetingService.setHasShownDeviceSelectionModal(false);
            }

            logger.debug('joining meeting');
            const durationMs = Date.now() - self.startTime;
            $rootScope.$broadcast('initiate-janus-call', { devicesPreviewedBeforeJoin: true, durationMs });

            connectivityService.setIsInDeviceSelectionFlow(false);
            self.cacheJoinEvent();

            virtualBackgroundService.stopFilteredBackgroundStream('device-selection');

            // remove body onclick
            $window.$('body').off('click', self.hideAllDeviceSelectionErrorPopOver);

            // If join as No Audio, default device preference as false
            if (self.disconnectAudio) {
                storageService.set('do-not-show-device-selection-flow', false);
            }
        }

        function cacheJoinEvent() {
            let cookieName = meetingService.getVerticalJoinFlowEnabled()
                ? 'joinedFromVerticalDevicePreview'
                : 'joinedFromDevicePreview';

            if (cookieService.get(cookieName) !== meetingService.getMeetingCode()) {
                storageService.remove('inMeetingAudioState');
                storageService.remove('inMeetingVideoState');
            }

            var tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            cookieService.put(cookieName, meetingService.getMeetingCode(), {
                expires: tomorrow,
                secure: true,
                samesite: 'strict'
            });
        }

        function cleanUp() {
            logger.debug('cleanup');

            connectivityService.setIsInDeviceSelectionFlow(false);
            self.stopActiveStream({ audio: true, video: true });
            avDeviceService.stopMicLevelTrackingForPreview();
            self.modalState = 'closed';
            $window.$($window).off('resize', self.onWindowResize);

            self.clearAudioOnlyStreamTimeout();
            self.clearVideoOnlyStreamTimeout();

            digest();
        }

        function shouldShowCamera() {
            if (
                !avDeviceService.hasCamera() ||
                !avDeviceService.getDevicePermissions().videoAllowed ||
                self.hasWebcamError
            ) {
                return false;
            }

            return true;
        }

        function getDeviceList() {
            return avDeviceService
                .enumerateDevices('list-devices')
                .then(function () {
                    self.populateDeviceLists();
                })
                .catch(function (err) {
                    logger.error('getDeviceList', 'Error enumerating devices', err);
                });
        }

        //Used for ng-click to be able to call previewDevice and be able to catch exceptions
        function previewDeviceClick(deviceObj) {
            self.previewDevice(deviceObj)
                .then(function (deviceAlreadyPreviewed) {
                    //If new Audio device was selected, re-populate device lists (to re-apply BT filter)
                    var isAudioDevice = deviceObj && deviceObj.deviceInfo && deviceObj.deviceInfo.kind === 'audioinput';
                    if (isAudioDevice && !deviceAlreadyPreviewed) {
                        self.populateDeviceLists();
                    }
                })
                .catch(function (err) {
                    logger.error('previewDeviceClick', 'Error in previewDevice', err);
                });
        }

        function previewDevice(deviceObj, ignoreCurrentlyPreviewedCheck) {
            var deferred = $q.defer();

            if (!deviceObj || !deviceObj.deviceInfo || !deviceObj.deviceInfo.deviceId) {
                deferred.reject('Invalid param');
                return deferred.promise;
            }

            if (!ignoreCurrentlyPreviewedCheck && self.isDeviceCurrentlyPreviewed(deviceObj)) {
                logger.debug(deviceObj.deviceInfo.kind + ' device already previewed: ' + deviceObj.deviceInfo.deviceId);
                deferred.resolve(true);
                return deferred.promise;
            }

            logger.debug(
                'Starting preview for ' + deviceObj.deviceInfo.kind + ' device: ' + deviceObj.deviceInfo.deviceId
            );

            if (deviceObj.deviceInfo.kind === 'audioinput') {
                analyticsWrapperService.eventTrack('Meeting - Device Selection Preview - Selected Microphone', {
                    deviceLabel: deviceObj.deviceInfo.label,
                    sfuEvent: true,
                    msgflow: 'device-preview:mic'
                });

                //If we're previewing a new device, clear out any existing popovers for that device
                self.removePopoverFromElement($window.$('.mic-dropdown-container .dropdown'));

                //Keeps track of current getUserMedia requests...
                //If a request comes back with a stream but this counter has been incremented,
                //that request is outdated and we can clean up the stream
                self.currentAudioStreamCounter++;

                //Enables the loading spinner -- this gets cleared when getUserMedia request returns
                self.setLoadingDeviceToTrue('audioInput');

                self.stopActiveStream({ audio: true });
                self.currentlySelectedMic = deviceObj;

                var audioOnlyConstraints = avDeviceService.generateConstraints('audio', deviceObj.deviceInfo.deviceId);
                self.getAudioOnlyStream(audioOnlyConstraints, self.currentAudioStreamCounter)
                    .then(function () {
                        deferred.resolve();
                    })
                    .catch(function (audioPreviewError) {
                        const errorMsg =
                            audioPreviewError && audioPreviewError.message
                                ? audioPreviewError.message
                                : audioPreviewError;
                        analyticsWrapperService.eventTrack(
                            'Meeting - Device Selection Preview - Error Retrieving Audio Stream',
                            {
                                error: errorMsg,
                                sfuEvent: true,
                                msgflow: 'device-preview:mic:error'
                            }
                        );

                        //error will be logged by whichever function calls this promise
                        deferred.reject(audioPreviewError);

                        //Timeout needed because if error occurs during onShowModal,
                        //the popover will appear in the wrong location
                        $timeout(function () {
                            self.devicePreviewErrorHandler('mic', audioPreviewError);
                        }, 500);
                    })
                    .finally(function () {
                        self.clearLoadingDevice('audioInput');
                    });
            } else if (deviceObj.deviceInfo.kind === 'videoinput') {
                analyticsWrapperService.eventTrack('Meeting - Device Selection Preview - Selected Webcam', {
                    deviceLabel: deviceObj.deviceInfo.label,
                    sfuEvent: true,
                    msgflow: 'device-preview:cam'
                });

                //If we're previewing a new device, clear out any existing popovers for that device
                self.removePopoverFromElement($window.$('.webcam-dropdown-container .dropdown'));

                //Keeps track of current getUserMedia requests...
                //If a request comes back with a stream but this counter has been incremented,
                //that request is outdated and we can clean up the stream
                self.currentVideoStreamCounter++;

                //Enables the loading spinner -- this gets cleared when getUserMedia request returns
                self.setLoadingDeviceToTrue('videoInput');

                //This flag will be true until the video 'play' event is received
                self.webcamPreviewLoading = true;
                digest();

                self.stopActiveStream({ video: true });
                self.currentlySelectedWebcam = deviceObj;

                // When user selects a new device from dropdown to view the preview, it results in blank/black
                // screen with Citrix SDK. In order to handle this we remove the existing video element from
                // the DOM, create a new one and then attach stream to it.
                try {
                    helperService.removePreviewVideoElement();
                } catch (e) {
                    logger.warn('previewDevice - It seems there is no video element to remove', e);
                } finally {
                    $timeout(
                        () => {
                            helperService.createPreviewVideoElement();
                        },
                        self.VDIRef.getVdiType() === executionEnvironmentEnum.Citrix ||
                            self.VDIRef.getVdiType() === executionEnvironmentEnum.VMware
                            ? 200
                            : 0
                    );
                }

                var videoOnlyConstraints = avDeviceService.generateConstraints('video', deviceObj.deviceInfo.deviceId);
                self.getVideoOnlyStream(videoOnlyConstraints, self.currentVideoStreamCounter)
                    .then(function () {
                        deferred.resolve();
                        if (
                            self.VDIRef.showVirtualBackgroundOption &&
                            virtualBackgroundService.hasVirtualBackground() &&
                            !self.filteredBgStreamRequested
                        ) {
                            self.filteredBgStreamRequested = true;
                            var filter = {};
                            filter.deviceId = videoOnlyConstraints.video.deviceId.exact;
                            filter.value = virtualBackgroundService.getVirtualBackground() || 'none';
                            virtualBackgroundService.requestFilteredBackgroundStream(filter, 'device-selection');
                        }
                        self.hasWebcamError = false;
                    })
                    .catch(function (videoPreviewError) {
                        const errorMsg =
                            videoPreviewError && videoPreviewError.message
                                ? videoPreviewError.message
                                : videoPreviewError;
                        analyticsWrapperService.eventTrack(
                            'Meeting - Device Selection Preview - Error Retrieving Video Stream',
                            {
                                error: errorMsg,
                                sfuEvent: true,
                                msgflow: 'device-preview:cam:error'
                            }
                        );

                        //error will be logged by whichever function calls this promise
                        deferred.reject(videoPreviewError);
                        self.hasWebcamError = true;

                        //Timeout needed because if error occurs during onShowModal,
                        //the popover will appear in the wrong location
                        $timeout(function () {
                            self.devicePreviewErrorHandler('webcam', videoPreviewError);
                        }, 500);
                    })
                    .finally(function () {
                        self.clearLoadingDevice('videoInput');
                    });
            } else {
                deferred.reject('invalid device kind ' + deviceObj.deviceInfo.kind);
            }

            return deferred.promise;
        }

        function isDeviceCurrentlyPreviewed(deviceObj) {
            var currentlySelectedDevice;

            if (!deviceObj || !deviceObj.deviceInfo) {
                return false;
            }

            //For audio input and video input, we need to check if stream is active

            if (deviceObj.deviceInfo.kind === 'audioinput') {
                currentlySelectedDevice = self.currentlySelectedMic;
            } else if (deviceObj.deviceInfo.kind === 'videoinput') {
                currentlySelectedDevice = self.currentlySelectedWebcam;
            } else if (deviceObj.deviceInfo.kind === 'audiooutput') {
                return (
                    self.currentlySelectedSpeaker.deviceInfo &&
                    self.currentlySelectedSpeaker.deviceInfo.deviceId === deviceObj.deviceInfo.deviceId &&
                    (!self.VDIRef.showTestAudioOutputOption ||
                        self.getSpeakerPreviewAudioSink() === deviceObj.deviceInfo.deviceId)
                );
            } else {
                return false;
            }

            try {
                if (
                    currentlySelectedDevice.deviceInfo &&
                    currentlySelectedDevice.deviceInfo.deviceId === deviceObj.deviceInfo.deviceId &&
                    currentlySelectedDevice.deviceInfo.label === deviceObj.deviceInfo.label &&
                    currentlySelectedDevice.stream &&
                    (self.VDIRef.getVdiType() === executionEnvironmentEnum.Citrix ||
                        currentlySelectedDevice.stream.active)
                ) {
                    return true;
                }
            } catch (e) {
                logger.error('isDeviceCurrentlyPreviewed', 'Error', e);
            }

            return false;
        }

        function devicePreviewErrorHandler(type, error) {
            if (error.message && error.message.indexOf('Permission denied by system') > -1) {
                if (type === 'mic') {
                    avDeviceService.setDevicePermissions({ audioAllowed: false });
                } else if (type === 'webcam') {
                    avDeviceService.setDevicePermissions({ videoAllowed: false });
                }
                if (helperService.isChromeOSXCatalina()) {
                    //system level permission issue
                    self.chromeWithSystemPermissionIssue = true;
                }
            } else if (error.name === 'NotReadableError' || error.name === 'NotAllowedError') {
                self.addToNotificationQueue(type + 'InUseError');
            } else if (error.name === 'TimedOutError') {
                self.addToNotificationQueue(type + 'TimedoutError');
            } else {
                //Handle any other error
                self.addToNotificationQueue(type + 'GenericError');
            }
        }

        function previewDefaultDevices() {
            var deferred = $q.defer();
            var allPromises = [];

            //Microphone
            if (self.currentlySelectedMic && self.currentlySelectedMic.deviceInfo) {
                logger.info(
                    `#previewDefaultDevices: Currently Selected Mic: ${self.currentlySelectedMic.deviceInfo.label}`
                );

                if (
                    (meetingService.canUseSystemMediaDevice() &&
                        avDeviceService.isSystemDevice(self.currentlySelectedMic.deviceInfo.deviceId)) ||
                    !self.isDeviceCurrentlyPreviewed(self.currentlySelectedMic)
                ) {
                    var micPromise = self
                        .previewDevice(self.currentlySelectedMic, meetingService.canUseSystemMediaDevice())
                        .catch(function (audioPreviewError) {
                            logger.error('previewDefaultDevices', 'Error for Audio', audioPreviewError);
                        });

                    allPromises.push(micPromise);
                }
            } else {
                analyticsWrapperService.eventTrack('Meeting - Device Selection Preview - Mic Not Found', {
                    sfuEvent: true,
                    msgflow: 'device-preview:no-mic'
                });

                logger.debug('previewDefaultDevices - No Selected Mic');
            }

            //Webcam
            if (self.currentlySelectedWebcam && self.currentlySelectedWebcam.deviceInfo) {
                logger.info(
                    `#previewDefaultDevices: Currently Selected Webcam: ${self.currentlySelectedWebcam.deviceInfo.label}`
                );

                if (!self.isDeviceCurrentlyPreviewed(self.currentlySelectedWebcam)) {
                    var webcamPromise = self
                        .previewDevice(self.currentlySelectedWebcam)
                        .catch(function (videoPreviewError) {
                            logger.error('previewDefaultDevices', 'Error for Video', videoPreviewError);
                        });

                    allPromises.push(webcamPromise);
                }
            } else {
                analyticsWrapperService.eventTrack('Meeting - Device Selection Preview - Webcam Not Found', {
                    sfuEvent: true,
                    msgflow: 'device-preview:no-cam'
                });

                logger.debug('previewDefaultDevices - No Selected Webcam');
            }

            //Speaker
            if (self.currentlySelectedSpeaker && self.currentlySelectedSpeaker.deviceInfo) {
                logger.info(
                    `#previewDefaultDevices Currently Selected Speaker: ${self.currentlySelectedSpeaker.deviceInfo.label}`
                );

                if (
                    (meetingService.canUseSystemMediaDevice() &&
                        avDeviceService.isSystemDevice(self.currentlySelectedSpeaker.deviceInfo.deviceId)) ||
                    !self.isDeviceCurrentlyPreviewed(self.currentlySelectedSpeaker)
                ) {
                    self.setAudioSink(self.currentlySelectedSpeaker.deviceInfo.deviceId);
                }
            } else {
                analyticsWrapperService.eventTrack('Meeting - Device Selection Preview - Speaker Not Found', {
                    sfuEvent: true,
                    msgflow: 'device-preview:no-speaker'
                });

                logger.debug('previewDefaultDevices - No Selected Speaker');
            }

            if (allPromises.length > 0) {
                $q.all(allPromises)
                    .catch(function (err) {
                        //Each promise has its own catch, so this catch block shouldn't ever be reached... logging just in case
                        logger.error('previewDefaultDevices', 'all promise error', err);
                    })
                    .finally(function () {
                        deferred.resolve();
                    });
            } else {
                deferred.resolve();
            }

            return deferred.promise;
        }

        function checkForUndetectedDevices() {
            if (self.webcams.length === 0) {
                self.addToNotificationQueue('webcamNotFoundError');
            } else {
                self.removePopoverIfItExists('webcamNotFoundError');
            }

            if (self.microphones.length === 0) {
                self.addToNotificationQueue('micNotFoundError');
            } else {
                self.removePopoverIfItExists('micNotFoundError');
            }

            if (self.speakers.length === 0) {
                self.addToNotificationQueue('speakerNotFoundError');
            } else {
                self.removePopoverIfItExists('speakerNotFoundError');
            }
        }

        function checkForBTHeadset() {
            if (!helperService.isWindows()) {
                return;
            }

            logger.debug('checkForBTHeadset');

            //If currently previewed Mic is a BT device, find its 'groupId'
            var btMicGroupId;
            if (
                self.currentlySelectedMic &&
                self.currentlySelectedMic.deviceInfo &&
                self.currentlySelectedMic.deviceInfo.label.toLowerCase().indexOf('bluetooth') > -1
            ) {
                btMicGroupId = self.currentlySelectedMic.deviceInfo.groupId;
            }

            var matchingBTHeadsetIndex = self.speakers.findIndex(function (speaker) {
                return speaker.deviceInfo.groupId === btMicGroupId;
            });

            //groupId is the only way we can guarantee that a BT Speaker is the same physical device as the BT Mic.
            //However, sometimes groupId does NOT match... in which case we should just return and not attempt to filter any BT Speakers.
            if (matchingBTHeadsetIndex === -1) {
                logger.debug('Could not find headset with matching groupId... will not filter BT devices');
                return;
            }

            if (btMicGroupId) {
                //Remove all BT speakers that do not have matching groupId (they will not output sound if BT mic is active)
                self.speakers = self.speakers.filter(function (speaker) {
                    return (
                        speaker.deviceInfo.label.toLowerCase().indexOf('bluetooth') === -1 ||
                        speaker.deviceInfo.groupId === btMicGroupId
                    );
                });

                //If currentlySelectedSpeaker was removed from list, update to next available speaker
                var selectedSpeaker;
                if (self.currentlySelectedSpeaker && self.currentlySelectedSpeaker.deviceInfo) {
                    selectedSpeaker = self.speakers.find(function (speaker) {
                        return speaker.deviceInfo.deviceId === self.currentlySelectedSpeaker.deviceInfo.deviceId;
                    });
                }

                if (!selectedSpeaker) {
                    //Ideally, fall back to matching BT headset (this is the only BT speaker that will work when BT mic is active)
                    var matchingHeadset = self.speakers.find(function (speaker) {
                        return speaker.deviceInfo.groupId === btMicGroupId;
                    });

                    var fallbackSpeaker = matchingHeadset || self.speakers[0];
                    if (fallbackSpeaker) {
                        logger.debug('Updating selected speaker to fallback:', fallbackSpeaker.deviceInfo.deviceId);
                        self.selectSpeaker(fallbackSpeaker);
                    }
                }
            }
        }

        function clearLoadingDevice(type) {
            if (type && self.devicesLoading[type] === true) {
                self.devicesLoading[type] = false;
                digest();
            }
        }

        function setLoadingDeviceToTrue(type) {
            if (type && self.devicesLoading[type] !== true) {
                self.devicesLoading[type] = true;
                digest();
            }
        }

        //The return value here is used for an HTML attribute (which is needed for CSS styling)
        //This should not be used as an accurate aspectRatio value (due to the default -1 and toFixed() being used)
        function getCurrentWebcamAspectRatio() {
            var aspectRatio = -1;

            if (self.currentlySelectedWebcam && self.currentlySelectedWebcam.stream) {
                var curTrack = self.currentlySelectedWebcam.stream.getVideoTracks()[0];
                if (curTrack && curTrack.getSettings) {
                    aspectRatio = curTrack.getSettings().aspectRatio || -1;
                    if (aspectRatio && aspectRatio !== -1) {
                        aspectRatio = aspectRatio.toFixed(2);
                    }
                }
            }

            return aspectRatio;
        }

        function selectSpeaker(deviceObj) {
            if (!deviceObj || !deviceObj.deviceInfo || !deviceObj.deviceInfo.deviceId) {
                logger.error('selectSpeaker', 'Invalid param for selectSpeaker', deviceObj);
                return;
            }

            if (deviceObj.deviceInfo.kind !== 'audiooutput') {
                logger.warn('selectSpeaker', 'Invalid device kind for selectSpeaker', deviceObj.deviceInfo.kind);
                return;
            }

            if (self.isDeviceCurrentlyPreviewed(deviceObj)) {
                logger.debug(
                    'speaker device already previewed, returning from selectSpeaker: ' + deviceObj.deviceInfo.deviceId
                );
                return;
            }

            analyticsWrapperService.eventTrack('Meeting - Device Selection Preview - Selected Speaker', {
                deviceLabel: deviceObj.deviceInfo.label,
                sfuEvent: true,
                msgflow: 'device-preview:speaker'
            });

            logger.debug('Selected speaker: ' + deviceObj.deviceInfo.deviceId);
            self.setAudioSink(deviceObj.deviceInfo.deviceId);

            self.currentlySelectedSpeaker = deviceObj;
        }

        function setAudioSink(sinkId) {
            try {
                var element = $window.angular.element('#device-preview-speaker-test');
                if (element && element[0] && typeof element[0].sinkId !== 'undefined') {
                    logger.debug('Setting audio sink');
                    element[0].setSinkId(sinkId);
                }
            } catch (e) {
                logger.error('setAudioSink', 'Error setting audio sink', e);
            }
        }

        function getSpeakerPreviewAudioSink() {
            var element = $window.$('#device-preview-speaker-test');
            if (element && element.get(0) && element.get(0).sinkId) {
                return element.get(0).sinkId;
            }

            return null;
        }

        function testSpeakers() {
            if (self.speakerOn) {
                // If the audio file is playing,
                // return and do not try to play it again
                // on top of itself
                return;
            }

            analyticsWrapperService.eventTrack('Meeting - Device Selection Preview - Test Speakers', {
                sfuEvent: true,
                msgflow: 'device-preview:test-speaker'
            });

            self.speakerOn = true;

            // Let the speakerOn variable be set to true
            // for 2 seconds, then set it to false so the user
            $timeout(function () {
                self.speakerOn = false;
            }, 2000); // 2 seconds
        }

        function setJoinWithPhoneAudio(joinWithPhoneAudio, suppressHeapEvent) {
            if (joinWithPhoneAudio && self.e2eePhoneAudioDisabled()) {
                return;
            }
            self.joinWithPhoneAudio = !!joinWithPhoneAudio;
            self.disconnectAudio = false;
            self.updateDeviceMessage();
            digest();

            if (suppressHeapEvent) {
                return;
            }

            if (self.joinWithPhoneAudio) {
                analyticsWrapperService.eventTrack('Meeting - Device Selection Preview - Selected Phone Audio', {
                    sfuEvent: true,
                    msgflow: 'device-preview:phone-audio'
                });
            } else {
                analyticsWrapperService.eventTrack('Meeting - Device Selection Preview - Selected Computer Audio', {
                    sfuEvent: true,
                    msgflow: 'device-preview:computer'
                });
            }
        }

        function setDisconnectAudio(disconnectAudio) {
            analyticsWrapperService.eventTrack('Meeting - Device Selection Preview - Selected No Audio', {
                sfuEvent: true,
                msgflow: 'device-preview:no-audio'
            });

            self.setJoinWithPhoneAudio(false, true);
            self.disconnectAudio = disconnectAudio;
            self.updateDeviceMessage();
        }

        function populateDeviceLists() {
            var deferred = $q.defer();

            self.clearDeviceLists();
            self.hasWebcamError = false;

            var micPromise = self
                .populateSingleDeviceList(avDeviceService.microphones, self.microphones, 'currentlySelectedMic')
                .catch(function (err) {
                    logger.error('populateDeviceLists', 'Error populating device list - Mic', err);
                });

            var webcamPromise = self
                .populateSingleDeviceList(avDeviceService.webcams, self.webcams, 'currentlySelectedWebcam')
                .catch(function (err) {
                    logger.error('populateDeviceLists', 'Error populating device list - Webcam', err);
                });

            var speakerPromise = self
                .populateSingleDeviceList(avDeviceService.speakers, self.speakers, 'currentlySelectedSpeaker')
                .catch(function (err) {
                    logger.error('populateDeviceLists', 'Error populating device list - Speaker', err);
                });

            $q.all([micPromise, webcamPromise, speakerPromise])
                .catch(function (err) {
                    //Each promise has its own catch, so this catch block shouldn't ever be reached... logging just in case
                    logger.error('populateDeviceLists', 'Error populating device lists', err);
                })
                .finally(function () {
                    self.checkForBTHeadset();
                    digest();

                    deferred.resolve();
                });

            return deferred.promise;
        }

        function populateSingleDeviceList(avDeviceServiceList, ctrlDeviceList, currentlySelectedVarName) {
            //For each device in avDeviceService's device list, generate a deviceObj and store in ctrl list

            var deferred = $q.defer();

            if (avDeviceServiceList && ctrlDeviceList && self[currentlySelectedVarName]) {
                //Prevents generateDeviceObj from retrieving getUserMedia stream for each device
                var noStream = true;

                if (avDeviceServiceList.length === 0) {
                    self[currentlySelectedVarName] = {};
                    deferred.resolve();
                } else {
                    //If currently selected device is not found in list, clear the var
                    if (self[currentlySelectedVarName].deviceInfo) {
                        var currentlySelectedDeviceExistsInList = avDeviceServiceList.find(function (device) {
                            return device.deviceId === self[currentlySelectedVarName].deviceInfo.deviceId;
                        });

                        if (!currentlySelectedDeviceExistsInList) {
                            self[currentlySelectedVarName] = {};
                        }
                    }

                    avDeviceServiceList.forEach(function (mediaDeviceInfo, index, arr) {
                        avDeviceService
                            .generateDeviceObj(mediaDeviceInfo, index + 1, noStream)
                            .then(function (newDeviceObj) {
                                if (
                                    newDeviceObj.inUse &&
                                    !self.isDeviceCurrentlyPreviewed(self[currentlySelectedVarName])
                                ) {
                                    self[currentlySelectedVarName] = newDeviceObj;
                                }

                                ctrlDeviceList.push(newDeviceObj);
                            })
                            .catch(function (err) {
                                logger.debug('Unable to generate device obj:', err);
                            })
                            .finally(function () {
                                if (index === arr.length - 1) {
                                    deferred.resolve();
                                }
                            });
                    });
                }
            }

            return deferred.promise;
        }

        function clearAudioOnlyStreamTimeout() {
            if (self.audioOnlyStreamTimeout) {
                $timeout.cancel(self.audioOnlyStreamTimeout);
                self.audioOnlyStreamTimeout = null;
            }
        }

        function clearVideoOnlyStreamTimeout() {
            if (self.videoOnlyStreamTimeout) {
                $timeout.cancel(self.videoOnlyStreamTimeout);
                self.videoOnlyStreamTimeout = null;
            }
        }

        function getAudioOnlyStream(audioOnlyConstraints, streamCounter) {
            var deferred = $q.defer();
            var getUserMediaTimedOut = false;

            if (audioOnlyConstraints && audioOnlyConstraints.audio) {
                logger.debug('Retrieving audio-only stream', audioOnlyConstraints);

                //set up a 10 second timer to throw a timeout error
                self.clearAudioOnlyStreamTimeout();
                self.audioOnlyStreamTimeout = $timeout(function () {
                    self.audioOnlyStreamTimeout = null;
                    getUserMediaTimedOut = true;
                    deferred.reject({ name: 'TimedOutError' });
                }, 10000);

                avDeviceService
                    .getStream(audioOnlyConstraints)
                    .then(function (audioOnlyStream) {
                        var stopStreamReason = '';

                        if (self.modalState === 'closed') {
                            stopStreamReason = 'modal closed';
                        } else if (self.currentAudioStreamCounter !== streamCounter) {
                            //This stream is from an older / unneeded getUserMedia request
                            stopStreamReason = 'outdated getUserMedia request';
                        } else if (getUserMediaTimedOut) {
                            stopStreamReason = 'getUserMedia timed out';
                        }

                        if (stopStreamReason) {
                            logger.debug(
                                'audio-only stream retrieved due to: ' + stopStreamReason + ', stopping stream'
                            );
                            self.stopStream(audioOnlyStream);
                        } else {
                            logger.debug('Successully retrieved audio-only stream');
                            self.currentlySelectedMic.stream = audioOnlyStream;

                            avDeviceService.stopMicLevelTrackingForPreview();
                            avDeviceService.trackMicLevelForPreview(audioOnlyStream, function (newMicLevel) {
                                self.micLevel = newMicLevel;
                                digest();
                            });
                        }

                        deferred.resolve();
                    })
                    .catch(function (audioOnlyStreamRetrievalError) {
                        deferred.reject(audioOnlyStreamRetrievalError);
                    })
                    .finally(function () {
                        self.clearAudioOnlyStreamTimeout();
                    });
            } else {
                //Skip audio stream retrieval
                deferred.resolve();
            }

            return deferred.promise;
        }

        function getVideoOnlyStream(videoOnlyConstraints, streamCounter) {
            var deferred = $q.defer();
            var getUserMediaTimedOut = false;

            if (videoOnlyConstraints && videoOnlyConstraints.video) {
                logger.debug('Retrieving video-only stream', videoOnlyConstraints);

                //set up a 10 second timer to throw a timeout error
                self.clearVideoOnlyStreamTimeout();
                self.videoOnlyStreamTimeout = $timeout(function () {
                    self.videoOnlyStreamTimeout = null;
                    getUserMediaTimedOut = true;
                    deferred.reject({ name: 'TimedOutError' });
                }, 10000);

                avDeviceService
                    .getStream(videoOnlyConstraints)
                    .then(function (videoOnlyStream) {
                        var stopStreamReason = '';

                        if (self.modalState === 'closed') {
                            stopStreamReason = 'modal closed';
                        } else if (self.currentVideoStreamCounter !== streamCounter) {
                            //This stream is from an older / unneeded getUserMedia request
                            stopStreamReason = 'outdated getUserMedia request';
                        } else if (getUserMediaTimedOut) {
                            stopStreamReason = 'getUserMedia timed out';
                        }

                        if (stopStreamReason) {
                            logger.debug(
                                'video-only stream retrieved due to: ' + stopStreamReason + ', stopping stream'
                            );
                            self.stopStream(videoOnlyStream);
                        } else {
                            logger.debug('Successully retrieved video-only stream');
                            self.currentlySelectedWebcam.stream = videoOnlyStream;

                            $timeout(
                                function () {
                                    const el = $window.$('#video-preview')[0];
                                    if (
                                        self.VDIRef.getVdiType() === executionEnvironmentEnum.Citrix ||
                                        self.VDIRef.getVdiType() === executionEnvironmentEnum.VMware
                                    ) {
                                        if (el) {
                                            el.addEventListener('loadedmetadata', _ => {
                                                self.onVideoPreviewPlay();
                                            });
                                            $window.Janus.videoElementIndex = self.VDIRef.mapVideoElement(
                                                el,
                                                $window.Janus.videoElementIndex
                                            );
                                            if (self.VDIRef.getVdiType() === executionEnvironmentEnum.VMware) {
                                                el.style.transform = 'scaleX(-1)';
                                                setTimeout(function () {
                                                    // Hack to update position of video element so that sdk's updateVideoElement is called
                                                    el.style.marginTop = '0.1px';
                                                }, 0);
                                            }
                                            if (el.srcObject !== videoOnlyStream) {
                                                el.srcObject = videoOnlyStream;
                                            }
                                        }
                                    } else {
                                        if (el !== undefined && el.srcObject !== videoOnlyStream) {
                                            el.srcObject = videoOnlyStream;
                                            self.onVideoPreviewPlay();
                                        }
                                    }
                                },
                                self.VDIRef.deviceSelectionAddTimerBeforeSettingFeedToVideoElement
                                    ? self.timeoutToSetFeedToVideoElementForVDI
                                    : self.timeoutToSetFeedToVideoElementForNonVDI
                            );
                        }
                        deferred.resolve();
                    })
                    .catch(function (videoOnlyStreamRetrievalError) {
                        deferred.reject(videoOnlyStreamRetrievalError);
                    })
                    .finally(function () {
                        self.clearVideoOnlyStreamTimeout();
                    });
            } else {
                //Skip video stream retrieval
                deferred.resolve();
            }

            return deferred.promise;
        }

        function stopActiveStream(streamTypes) {
            if (!streamTypes) {
                return;
            }

            if (streamTypes.audio && self.currentlySelectedMic && self.currentlySelectedMic.stream) {
                logger.debug('Stopping audio-only stream');

                self.stopStream(self.currentlySelectedMic.stream);
                self.currentlySelectedMic.stream = undefined;
                digest();
            }

            if (streamTypes.video && self.currentlySelectedWebcam && self.currentlySelectedWebcam.stream) {
                logger.debug('Stopping video-only stream');

                self.stopStream(self.currentlySelectedWebcam.stream);
                self.currentlySelectedWebcam.stream = undefined;
                if (self.VDIRef.getVdiType() === executionEnvironmentEnum.Citrix) {
                    //For Citrix, we need to remove the srcObject from the video element to avoid getBoundClientRect issues
                    logger.log('stopActiveStream', 'Removing srcObject from video element');
                    const el = $window.$('#video-preview')[0];
                    el.srcObject = null;
                    el.removeEventListener('loadedmetadata', self.onVideoPreviewPlay);
                }
                digest();
            }

            virtualBackgroundService.stopFilteredBackgroundStream('device-selection');
        }

        function stopStream(stream) {
            if (stream) {
                if (stream.stop) {
                    stream.stop();
                }

                if (stream.getTracks) {
                    stream.getTracks().forEach(function (track) {
                        track.stop();
                    });
                }
            }
        }

        function clearDeviceLists() {
            self.webcams = [];
            self.microphones = [];
            self.speakers = [];
            digest();
        }

        function toggleShowDeviceSelectionCheckbox(event) {
            var checkBoxState = event && event.currentTarget ? event.currentTarget.checked : false;
            storageService.set('do-not-show-device-selection-flow', checkBoxState);

            if (checkBoxState) {
                analyticsWrapperService.eventTrack(
                    'Meeting - Device Selection Preview - Checked Do Not Show Again Checkbox',
                    {
                        sfuEvent: true,
                        msgflow: 'device-preview:again-yes'
                    }
                );
            } else {
                analyticsWrapperService.eventTrack(
                    'Meeting - Device Selection Preview - Unchecked Do Not Show Again Checkbox',
                    {
                        sfuEvent: true,
                        msgflow: 'device-preview:again-no'
                    }
                );
            }
        }

        function setupDeviceBlockedPopover() {
            var permissions = avDeviceService.getDevicePermissions();

            var micBlocked = avDeviceService.hasMicrophone() && !permissions.audioAllowed;
            var webcamBlocked = avDeviceService.hasCamera() && !permissions.videoAllowed;

            if (micBlocked && webcamBlocked) {
                self.showMicrophoneAndWebcamDeviceBlockedPopOver();
            } else if (micBlocked) {
                self.showDeviceBlockedPopoverFor('microphone');
            } else if (webcamBlocked) {
                self.showDeviceBlockedPopoverFor('webcam');
            }

            $window.$('body').on('click', self.hideAllDeviceSelectionErrorPopOver);

            digest();
        }

        function usePhoneAudioDueToDeviceError() {
            if (self.e2eePhoneAudioDisabled()) {
                return;
            }

            self.setJoinWithPhoneAudio(true);
            $window.$('.popover').popover('hide');
            logger.debug('falling back to phone audio');
        }

        function showMicrophoneAndWebcamDeviceBlockedPopOver() {
            self.showDevicePopover(
                $window.$('.mic-dropdown-container .no-permission-error'),
                $window.$('#deviceSelectionDevicesBlockedPopoverContent').html(),
                '.mic-dropdown-container .no-permission-error',
                { name: 'micAndWebcamBlocked' }
            );
            self.showDevicePopover(
                $window.$('.webcam-dropdown-container .no-permission-error'),
                $window.$('#deviceSelectionDevicesBlockedPopoverContent').html(),
                '.webcam-dropdown-container .no-permission-error',
                { name: 'micAndWebcamBlocked' }
            );
        }

        function showDeviceBlockedPopoverFor(type) {
            if (type === 'microphone') {
                self.showDevicePopover(
                    $window.$('.mic-dropdown-container .no-permission-error'),
                    $window.$('#deviceSelectionMicrophoneBlockedPopoverContent').html(),
                    '.mic-dropdown-container .no-permission-error',
                    { name: 'micBlocked' }
                );
            } else if (type === 'webcam') {
                self.showDevicePopover(
                    $window.$('.webcam-dropdown-container .no-permission-error'),
                    $window.$('#deviceSelectionCameraBlockedPopoverContent').html(),
                    '.webcam-dropdown-container .no-permission-error',
                    { name: 'webcamBlocked' }
                );
            }
        }

        function getDevicePopoverPlacement(tooltip, source) {
            if ($window.$(window).width() < 768) {
                return 'bottom';
            }

            try {
                //This function doesn't need to return a placement string if it manually applies the placement class

                var parentPosition = $window.$(source).offset();
                var parentWidth = $window.$(source).outerWidth();
                var top = parentPosition.top - 15;
                var left = parentPosition.left + parentWidth;

                $timeout(function () {
                    $window.$(tooltip).addClass('right');
                    $window.$(tooltip).css({ top: top, left: left });
                    $window.$(tooltip).find('.arrow').css({ top: 28 });
                });

                return '';
            } catch (e) {
                logger.error('getDevicePopoverPlacement', 'Error getting device popover placement', e);

                //Default val
                return 'right';
            }
        }

        function showDevicePopover(element, content, viewport, opts) {
            $window.$('.popover').popover('hide');

            var popoverParams = {
                trigger: 'manual',
                placement: self.getDevicePopoverPlacement,
                viewport: { selector: viewport },
                html: true,
                animation: true,
                content: $compile(content)($scope),
                container: '#deviceSelection'
            };

            var popover = element
                .popover(popoverParams)
                .off('mouseenter')
                .on('mouseenter', function () {
                    var _this = this;
                    if ($window.$(this).attr('aria-describedby')) {
                        //already shown and visible
                        return;
                    }
                    $window.$('.popover').popover('hide');
                    $window.$(this).popover('show');
                });

            if (opts && opts.once) {
                popover.on('hidden.bs.popover', function () {
                    self.removePopoverFromElement(element);
                });
            }

            if (popover.data('bs.popover') && popover.data('bs.popover').tip()) {
                popover.data('bs.popover').tip().addClass('device-selection-popover');

                if (opts && opts.class) {
                    popover.data('bs.popover').tip().addClass(opts.class);
                }
            }

            element.addClass('has-popover');

            if (opts && opts.name) {
                element.prop('popoverName', opts.name);
            }

            if (element.is(':visible')) {
                element.popover('show');
            }
        }

        //Only show device detection popover if no other popovers are showing
        //(if existing popover is device detection related, it can be overwritten)
        function showDeviceDetectionPopover(elementId, popoverContainer) {
            var element = $window.$('.device-selection-popover');

            if (element.length === 0) {
                self.showDevicePopover($window.$(popoverContainer), $window.$(elementId).html(), popoverContainer, {
                    once: true,
                    class: 'device-detection'
                });
            } else if (element.hasClass('device-detection')) {
                self.removePopoverFromElement(element);

                //Timeout needed for removePopoverFromElement to finish clearing existing popover
                $timeout(function () {
                    self.showDevicePopover($window.$(popoverContainer), $window.$(elementId).html(), popoverContainer, {
                        once: true,
                        class: 'device-detection'
                    });
                }, 500);
            }
        }

        function showPopoverForDeviceChange(oldListLengths, newListLengths) {
            var popoverContainer = null;
            var deviceAdded = null;

            if (oldListLengths.webcams < newListLengths.webcams) {
                //Webcam removed
                if (!popoverContainer) {
                    deviceAdded = true;
                    popoverContainer = self.popoverElement.camDropDown;
                }
            } else if (oldListLengths.webcams > newListLengths.webcams) {
                //Webcam added
                if (!popoverContainer) {
                    deviceAdded = false;
                    popoverContainer = self.popoverElement.camDropDown;
                }
            }

            //Ignore speaker/mic changes if phone-audio is enabled
            if (!self.joinWithPhoneAudio) {
                if (oldListLengths.speakers < newListLengths.speakers) {
                    //Speaker removed
                    if (!popoverContainer) {
                        deviceAdded = true;
                        popoverContainer = self.popoverElement.speakerDropDown;
                    }
                } else if (oldListLengths.speakers > newListLengths.speakers) {
                    //Speaker added
                    if (!popoverContainer) {
                        deviceAdded = false;
                        popoverContainer = self.popoverElement.speakerDropDown;
                    }
                }

                if (oldListLengths.microphones < newListLengths.microphones) {
                    //Mic removed
                    if (!popoverContainer) {
                        deviceAdded = true;
                        popoverContainer = self.popoverElement.micDropDown;
                    }
                } else if (oldListLengths.microphones > newListLengths.microphones) {
                    //Mic added
                    if (!popoverContainer) {
                        deviceAdded = false;
                        popoverContainer = self.popoverElement.micDropDown;
                    }
                }
            }

            if (popoverContainer !== null && deviceAdded !== null) {
                if (!deviceAdded) {
                    //Device was removed
                    self.showDeviceDetectionPopover('#deviceSelectionDeviceDisconnected', popoverContainer);
                } else {
                    //Device was added
                    self.showDeviceDetectionPopover('#deviceSelectionDeviceConnected', popoverContainer);
                }
            }
        }

        function hideAllDeviceSelectionErrorPopOver(event) {
            var container = $window.$('.popover');
            var target = $window.$(event.target);
            if (container.has(target).length === 0) {
                $window.$('.popover').popover('hide');
                self.showNextAvailablePopover();
            }
        }

        function getDevicePermissionFor(type) {
            var permissions = avDeviceService.getDevicePermissions();
            if (type === 'webcam') {
                return permissions.videoAllowed === true;
            } else if (type === 'microphone') {
                return permissions.audioAllowed === true;
            }
        }

        function addToNotificationQueue(name) {
            var template = self.devicePopovers.find(function (template) {
                return template.name === name;
            });

            if (!template) {
                logger.error('addToNotificationQueue', 'addToNotificationQueue - template not found', name);
                return;
            }

            //special case for permission as that should overwrite all other errors
            //so don't add new notification if the notification we are adding is for mic/webcam and we don't have permission
            if (self.shouldIgnorePopoverTemplate(template)) {
                logger.debug(
                    'addToNotificationQueue not done because permission not granted for ' + template.device + ':',
                    template.name
                );
                return;
            }

            //Check if template already exists in queue before adding
            var templateIndex = self.devicePopoversQueue[template.device].findIndex(function (templateToCheck) {
                return templateToCheck.name === name;
            });

            if (templateIndex === -1) {
                logger.debug('addToNotificationQueue adding:', template.name);
                self.devicePopoversQueue[template.device].push(template);
            }

            var popoverElement = $window.$('.device-selection-popover');
            //if there are no existing popovers, start showing the next available notification
            if (popoverElement.length === 0) {
                self.showNextAvailablePopover();
            } else if (popoverElement.hasClass('device-detection')) {
                self.removePopoverFromElement(popoverElement);

                //Timeout needed for removePopoverFromElement to finish clearing existing popover
                $timeout(function () {
                    self.showNextAvailablePopover();
                }, 500);
            }
        }

        function getHighestAvailablePriorityQueue() {
            if (
                self.devicePopoversQueue.speaker &&
                self.devicePopoversQueue.speaker.length > 0 &&
                !self.joinWithPhoneAudio
            ) {
                return self.devicePopoversQueue.speaker;
            } else if (
                self.devicePopoversQueue.mic &&
                self.devicePopoversQueue.mic.length > 0 &&
                !self.joinWithPhoneAudio
            ) {
                return self.devicePopoversQueue.mic;
            } else if (self.devicePopoversQueue.webcam && self.devicePopoversQueue.webcam.length > 0) {
                return self.devicePopoversQueue.webcam;
            } else {
                return [];
            }
        }

        function showNextAvailablePopover() {
            var queueToUse = self.getHighestAvailablePriorityQueue();
            var template = queueToUse.shift();
            if (template) {
                $timeout(function () {
                    self.showDevicePopover(
                        $window.$(template.element),
                        $window.$(template.content).html(),
                        template.element,
                        { name: template.name }
                    );
                });
            }
        }

        function removePopoverIfItExists(popoverName) {
            try {
                var template = self.devicePopovers.find(function (template) {
                    return template.name === popoverName;
                });

                if (template) {
                    var element = $window.$(template.element);

                    var popoverId = element.attr('aria-describedby');
                    if (popoverId) {
                        //has popover id, popover is showing
                        //check if content class matches popovername in the popover
                        var match = '#' + popoverId + ' .' + popoverName;
                        var popover = $window.$(match);
                        if (!(popover && popover.length > 0)) {
                            return;
                        }
                    }

                    if (element && element.hasClass('has-popover') && element.prop('popoverName') === popoverName) {
                        logger.debug('Removing popover:', popoverName);
                        self.removePopoverFromElement(element);
                    }

                    //Find index of popover to be removed from queue, and then remove from queue if found
                    var index = self.devicePopoversQueue[template.device].findIndex(function (element) {
                        return element.name === popoverName;
                    });

                    if (index > -1) {
                        logger.debug('Removing popover from queue:', template.name);
                        self.devicePopoversQueue[template.device].splice(index, 1);
                    }
                }
            } catch (e) {
                logger.error('removePopoverIfItExists', 'Error removing popover', e);
            }
        }

        function removePopoverFromElement(element) {
            if (element) {
                element.popover('destroy');
                element.off('mouseenter');
                element.removeClass('has-popover device-detection');
                element.removeProp('popoverName');
                digest();
            }
        }

        function shouldIgnorePopoverTemplate(template) {
            //If you do not have device permissions granted,
            //It is implied that the current popover being shown is permissions-related,
            //and therefore we do ignore any other popovers related to that device

            if (template) {
                if (
                    template.device === 'webcam' &&
                    avDeviceService.hasCamera() &&
                    !self.getDevicePermissionFor('webcam')
                ) {
                    return true;
                }

                if (
                    template.device === 'mic' &&
                    avDeviceService.hasMicrophone() &&
                    !self.getDevicePermissionFor('microphone')
                ) {
                    return true;
                }
            }

            return false;
        }

        function onDeviceChangedDuringDevicePreview() {
            logger.debug('device change detected');

            //When device change detected, we don't have any info which devices were added/removed, etc.
            //So we re-populate the device lists and re-init preview if previously selected devices were disconnected

            var oldDevicesListLengths = {
                microphones: self.microphones.length,
                webcams: self.webcams.length,
                speakers: self.speakers.length
            };

            avDeviceService
                .determineMicAndCamAvailability()
                .catch(function (err) {
                    logger.error(
                        'onDeviceChangedDuringDevicePreview',
                        'Error checking device availability on device change',
                        err
                    );
                })
                .then(function () {
                    return self.checkDevicePermissions();
                })
                .catch(function (err) {
                    logger.error('onDeviceChangedDuringDevicePreview', 'Error in checkDevicePermissions', err);
                })
                .then(function () {
                    return self.populateDeviceLists();
                })
                .catch(function (err) {
                    logger.error(
                        'onDeviceChangedDuringDevicePreview',
                        'Error re-populating device lists on device change',
                        err
                    );
                })
                .then(function () {
                    self.updateDeviceMessage();
                    return self.previewDefaultDevices();
                })
                .catch(function (err) {
                    logger.error(
                        'onDeviceChangedDuringDevicePreview',
                        'Error previewing devices on device change',
                        err
                    );
                })
                .finally(function () {
                    self.checkForUndetectedDevices();

                    if (self.getHighestAvailablePriorityQueue().length > 0) {
                        //Device detection popovers are the least prioritized...
                        //So if theres a popover in the queue, do not check for device change
                        return;
                    }

                    //Timeout needed for dom elements to finish updating due to device change
                    $timeout(function () {
                        self.showPopoverForDeviceChange(oldDevicesListLengths, {
                            microphones: self.microphones.length,
                            webcams: self.webcams.length,
                            speakers: self.speakers.length
                        });
                    }, 500);
                });
        }

        function onE2EEEnabled() {
            if (self.joinWithPhoneAudio) {
                self.joinWithPhoneAudio = false;
                analyticsWrapperService.eventTrack(
                    'Meeting - Device Selection Preview - Force switch to computer audio cause e2ee',
                    {
                        sfuEvent: true,
                        msgflow: 'e2ee:force-computer'
                    }
                );
            }

            digest();
        }

        function onScopeDestroyed() {
            self.cleanUp();
        }

        function applyVideoPreviewListener() {
            if (!self.videoPreviewListenerApplied) {
                self.videoPreviewListenerApplied = true;
                $window.$('#video-preview').on('play', self.onVideoPreviewPlay);
            }
        }

        function onVideoPreviewPlay() {
            if (self.webcamPreviewLoading) {
                self.webcamPreviewLoading = false;
                digest();
            }
        }

        function refreshDeviceListAndPreviewDefault() {
            self.getDeviceList()
                .catch(function (err) {
                    logger.error('refreshDeviceListAndPreviewDefault', 'Error in getDeviceList', err);
                })
                .then(function () {
                    self.previewDefaultDevices();
                });
        }

        function onVirtualBackgroundStreamError(ev, data) {
            if (data && data.identifier == 'device-selection') {
                if (data.error) {
                    self.hasWebcamError = true;
                }
            }
        }

        function onVirtualBackgroundStreamStarted(ev, data) {
            if (data && data.identifier == 'device-selection') {
                self.filteredBgStreamRequested = false;
                self.hasWebcamError = false;

                if (
                    self.modalState === 'open' &&
                    self.currentlySelectedWebcam.stream &&
                    self.currentlySelectedWebcam.stream.getTracks
                ) {
                    if (self.currentlySelectedWebcam.stream !== data.stream) {
                        logger.info(
                            'onVirtualBackgroundStreamStarted',
                            'stopping previous currentlySelectedWebcam.stream tracks'
                        );
                        [...self.currentlySelectedWebcam.stream.getTracks()].forEach(track => {
                            try {
                                track.stop();
                            } catch (e) {}
                        });
                    }

                    self.currentlySelectedWebcam.stream = data.stream;
                    const el = $window.$('#video-preview')[0];
                    if (el) {
                        el.srcObject = self.currentlySelectedWebcam.stream;
                    }
                } else {
                    logger.warn(
                        'onVirtualBackgroundStreamStarted',
                        'Modal was closed before virtual background has started, stopping vbg stream'
                    );
                    self.stopStream(data.stream);
                    virtualBackgroundService.stopFilteredBackgroundStream('device-selection');
                }
            }
        }

        function onVirtualBackgroundInitialized(ev, data) {
            self.videoFilterLoading = !data;
            digest();
        }

        function e2eePhoneAudioDisabled() {
            return meetingService.e2eeEnabled();
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }

        function toggleMicPreview() {
            if (self.micPreviewBtnDisabled()) {
                return;
            }

            logger.debug('Vertical Join Flow - Toggle Mic Preview to ' + !self.micPreviewOn);
            self.micPreviewOn = !self.micPreviewOn;

            self.updateDeviceMessage();
        }

        function micPreviewBtnDisabled() {
            if (!attendeeService.getIsHost()) {
                if (
                    meetingService.getJoinAudioMuted() ||
                    !meetingService.isAllowedByHostSecuritySettings('canUnmuteAudio') ||
                    self.isJoinMuteLimitReach()
                ) {
                    return true;
                }
            }

            if (
                self.joinWithPhoneAudio ||
                self.disconnectAudio ||
                !avDeviceService.hasMicrophone() ||
                !avDeviceService.getDevicePermissions() ||
                !avDeviceService.getDevicePermissions().audioAllowed
            ) {
                return true;
            }

            return false;
        }

        function webcamPreviewBtnDisabled(ignoreLoading) {
            if (!attendeeService.getIsHost() && !meetingService.isAllowedByHostSecuritySettings('canUnmuteWebcam')) {
                return true;
            }

            if (meetingService.e2eeEnabled()) {
                return true;
            }

            if (
                (self.webcamPreviewLoading && !ignoreLoading) ||
                !avDeviceService.hasCamera() ||
                !avDeviceService.getDevicePermissions() ||
                !avDeviceService.getDevicePermissions().videoAllowed
            ) {
                return true;
            }

            return false;
        }

        function onUpdateLocalJoinAudioMuted() {
            if (self.micPreviewOn && meetingService.getJoinAudioMuted()) {
                self.micPreviewOn = false;
            }
            self.updateDeviceMessage();
            digest();
        }

        function onSecuritySettingsUpdated() {
            if (self.micPreviewOn && !meetingService.isAllowedByHostSecuritySettings('canUnmuteAudio')) {
                self.micPreviewOn = false;
            }
        }

        function getMicPreviewTooltip() {
            if (self.joinWithPhoneAudio) {
                return localizationService.translate(
                    'DEVICE_SELECTION_PREVIEW.VERTICAL_JOIN_FLOW.JOIN_WITH_PHONE_AUDIO'
                );
            } else if (self.disconnectAudio) {
                return localizationService.translate(
                    'DEVICE_SELECTION_PREVIEW.VERTICAL_JOIN_FLOW.JOIN_WITH_AUDIO_DISCONNECT'
                );
            } else if (!avDeviceService.hasMicrophone()) {
                return localizationService.translate('DEVICE_SELECTION_PREVIEW.GENERAL_ERRORS.TITLE.MIC_NOT_FOUND');
            } else if (
                !avDeviceService.getDevicePermissions() ||
                !avDeviceService.getDevicePermissions().audioAllowed
            ) {
                return localizationService.translate('DEVICE_SELECTION_PREVIEW.GENERAL_ERRORS.TITLE.MIC_GENERIC_ERROR');
            } else if (
                !attendeeService.getIsHost() &&
                (meetingService.getJoinAudioMuted() ||
                    !meetingService.isAllowedByHostSecuritySettings('canUnmuteAudio') ||
                    self.isJoinMuteLimitReach())
            ) {
                return localizationService.translate(
                    'DEVICE_SELECTION_PREVIEW.VERTICAL_JOIN_FLOW.HOST_HAS_REQUESTED_ATTENDEES_JOIN_MUTED'
                );
            } else if (self.micPreviewOn) {
                return localizationService.translate('DEVICE_SELECTION_PREVIEW.VERTICAL_JOIN_FLOW.MUTE_MIC');
            } else {
                return localizationService.translate('DEVICE_SELECTION_PREVIEW.VERTICAL_JOIN_FLOW.UNMUTE_MIC');
            }
        }

        function getWebcamPreviewTooltip() {
            if (!avDeviceService.hasCamera()) {
                return localizationService.translate('HEADER.SETTINGS.NO_WEBCAM_AVAILABLE');
            } else if (
                !avDeviceService.getDevicePermissions() ||
                !avDeviceService.getDevicePermissions().videoAllowed
            ) {
                return localizationService.translate(
                    'DEVICE_SELECTION_PREVIEW.GENERAL_ERRORS.TITLE.WEBCAM_GENERIC_ERROR'
                );
            }
            if (!attendeeService.getIsHost() && !meetingService.isAllowedByHostSecuritySettings('canUnmuteWebcam')) {
                return localizationService.translate(
                    'DEVICE_SELECTION_PREVIEW.VERTICAL_JOIN_FLOW.HOST_HAS_REQUESTED_ATTENDEES_JOIN_VMUTED'
                );
            } else if (meetingService.e2eeEnabled()) {
                return localizationService.translate('ATTENDEE_LIST.TOOLTIP.HOST_HAS_DISABLED_THIS_FEATURE');
            } else {
                return '';
            }
        }

        function updateDeviceMessage() {
            if (self.disconnectAudio) {
                self.deviceMessage = localizationService.translate(
                    'DEVICE_SELECTION_PREVIEW.VERTICAL_JOIN_FLOW.JOINING_WITH_MIC_MUTED'
                );
                return;
            }
            if (self.micPreviewOn && !self.joinWithPhoneAudio && avDeviceService.hasMicrophone()) {
                if (
                    !attendeeService.getIsHost() &&
                    (meetingService.getJoinAudioMuted() || self.isJoinMuteLimitReach())
                ) {
                    self.deviceMessage = localizationService.translate(
                        'DEVICE_SELECTION_PREVIEW.VERTICAL_JOIN_FLOW.JOINING_WITH_MIC_MUTED'
                    );
                } else {
                    self.deviceMessage = localizationService.translate(
                        'DEVICE_SELECTION_PREVIEW.VERTICAL_JOIN_FLOW.JOINING_WITH_MIC_UNMUTED'
                    );
                }
            } else {
                self.deviceMessage = localizationService.translate(
                    'DEVICE_SELECTION_PREVIEW.VERTICAL_JOIN_FLOW.JOINING_WITH_MIC_MUTED'
                );
            }
        }

        function getDoNotShowDialogTooltip() {
            if (self.joinWithPhoneAudio) {
                return localizationService.translate(
                    'DEVICE_SELECTION_PREVIEW.VERTICAL_JOIN_FLOW.FUTURE_MEETING_PHONE_AUDIO'
                );
            }
            if (self.micPreviewOn) {
                return localizationService.translate(
                    'DEVICE_SELECTION_PREVIEW.VERTICAL_JOIN_FLOW.FUTURE_MEETING_MIC_ON'
                );
            } else if (
                !attendeeService.getIsHost() &&
                (meetingService.getJoinAudioMuted() || self.isJoinMuteLimitReach())
            ) {
                return storageService.get('join-flow-audio-muted') === false
                    ? localizationService.translate('DEVICE_SELECTION_PREVIEW.VERTICAL_JOIN_FLOW.FUTURE_MEETING_MIC_ON')
                    : localizationService.translate(
                          'DEVICE_SELECTION_PREVIEW.VERTICAL_JOIN_FLOW.FUTURE_MEETING_MIC_OFF'
                      );
            } else {
                return localizationService.translate(
                    'DEVICE_SELECTION_PREVIEW.VERTICAL_JOIN_FLOW.FUTURE_MEETING_MIC_OFF'
                );
            }
        }

        // VDI only - if data is true, then hide preview after brief timeout, else show preview.
        function onModalToggledInPreview(e, data) {
            if (data) {
                $timeout(function () {
                    $window.$('#video-preview').css('display', 'none');
                }, 200);
            } else {
                // TODO: why not remove inline style, so that css from file is applied?
                $window.$('#video-preview').css('display', 'inline-block');
            }
        }

        function isJoinMuteLimitReach() {
            if (attendeeListService.getAttendeeList().length > 20) {
                return true;
            }
            return false;
        }
    }
]);
